module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/icon-arrow-up-a1bb679075f9f3d8232176de8122f5a4.png";